import SearchSelectedFilters from '@ui/Search/SelectedFilters/component'

export default (): void => {
  const el = document.querySelector<HTMLElement>('.search-selected-filters')

  el &&
    SearchSelectedFilters(el, {
      onButtonClick: (buttonEl) => {
        const id = buttonEl.getAttribute('data-id') as string
        const action = buttonEl.getAttribute('data-action') as string

        if (id && document.getElementById(id)) {
          if (action === 'click') {
            ;(<HTMLInputElement>document.getElementById(id)).click()
          } else if (action === 'nullify') {
            ;(<HTMLInputElement>document.getElementById(id)).value = ''
          }
        }

        if (document.getElementById('filter_offers_page')) {
          ;(<HTMLInputElement>document.getElementById('filter_offers_page')).value = '1'
        }
        if (document.getElementById('filter_offers_filter')) {
          ;(<HTMLInputElement>document.getElementById('filter_offers_filter')).click()
        }
      },
    })
}
